const FeatureConfigIds = {
  STAMP_GROUP: 'stamp-group',
  STAMP_MODULE: 'stamp-module',
  CUSTOM_FIELDS: 'custom-fields',
};

const FeatureConfigRules = {
  [FeatureConfigIds.STAMP_MODULE]: ({ activate, activateUpload, activateRevenueStamp }) => (
    activate || activateUpload || activateRevenueStamp
  ),
  [FeatureConfigIds.STAMP_GROUP]: ({ activate, activateGroup }) => activate && activateGroup,
  [FeatureConfigIds.CUSTOM_FIELDS]: ({ customFieldsEnabled }) => !!customFieldsEnabled,
};

export {
  FeatureConfigIds, FeatureConfigRules,
};
